import { Fragment, useState } from "react";
import {
  Autocomplete,
  Switch,
  Grid2 as Grid,
  FormControlLabel,
  TextField,
  CircularProgress,
} from "@mui/material";
import { Notifications } from "@mui/icons-material";
import BTDialogBox from "../../../components/BTDialgBox";
import BTInput from "../../../components/BTInput";
import { roles } from "../../../dropdownData";
import secureLocalStorage from "react-secure-storage";
import authService from "../../../services/auth-service";
import { useNotification } from "../../../context";
import { isEqual } from "lodash";
import BTTypography from "../../../components/BTTypography";
import { manage_store_data } from "../../../store/functions";
const Adduser = ({ open, setOpen }) => {
  const {
    u_id,
    admin_u_id,
    u_type,
    p_attr,
    p_billing,
    p_conv_rate,
    p_party,
    p_pl,
    p_replies,
    p_reports,
    p_results,
    p_returns,
    p_service,
    p_size,
    p_submit,
    p_user,
  } = secureLocalStorage.getItem("userdata");
  const userHasPermission = {
    p_size: p_size,
    p_service: p_service,
    p_pl: p_pl,
    p_conv_rate: p_conv_rate,
    p_party: p_party,
    p_attr: p_attr,
    p_user: p_user,
    p_submit: p_submit,
    p_results: p_results,
    p_replies: p_replies,
    p_returns: p_returns,
    p_billing: p_billing,
    p_reports: p_reports,
  };
  const { addNotification } = useNotification();
  const { value, actionType } = open;
  const filterRoles = roles.filter(
    ({ value }) => value !== u_type && value !== 1
  );

  const initialState = {
    first_name: "",
    middle_name: "",
    last_name: "",
    u_desc: "",
    u_email: "",
    u_mo_no: "",
    u_password: "",
    u_type: filterRoles[0]?.value,
    parent_u_id: u_id,
    admin_u_id: u_type === 1 ? u_id : admin_u_id,
    u_users: "",
    u_country_details: "",
    p_size: null,
    p_service: null,
    p_pl: null,
    p_conv_rate: null,
    p_party: null,
    p_attr: null,
    p_user: null,
    p_submit: null,
    p_results: null,
    p_replies: null,
    p_returns: null,
    p_billing: null,
    p_reports: null,
    u_created_by: u_id,
    u_updated_by: u_id,
    p_delete: {
      submit: null,
      result: null,
      reply: null,
      return: null,
      bill: null,
    },
  };

  const [formData, setFormData] = useState(
    actionType === 1 ? initialState : value
  );
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const validateForm = (data) => {
    const {
      first_name,
      middle_name,
      last_name,
      u_email,
      u_mo_no,
      u_password,
      u_type,
    } = data;
    const errors = {};
    const addError = (field, message) => (errors[field] = message);
    if (!first_name?.trim()) {
      addError("first_name", "First name is required");
    }
    if (!middle_name?.trim()) {
      addError("middle_name", "Middle name is required");
    }
    if (!last_name?.trim()) {
      addError("last_name", "Last name is required");
    }
    if (!u_email?.trim()) {
      addError("u_email", "Email address is required");
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(u_email)) {
      addError("u_email", "Invalid email format");
    }
    if (!u_mo_no?.trim()) {
      addError("u_mo_no", "Mobile Number is required");
    } else if (!/^\d{10,15}$/.test(u_mo_no)) {
      addError("u_mo_no", "Invalid mobile number");
    }
    if (!u_password?.trim()) {
      addError("u_password", "Password is required");
    }
    if (!u_type) {
      addError("u_type", "User type is required");
    }
    return Object.keys(errors).length > 0 ? errors : {};
  };
  const handleClose = () => {
    setOpen(false);
    setFormData(initialState);
  };

  const submitUser = async (e) => {
    e.preventDefault();
    const newErrors = validateForm(formData);
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      if (actionType === 2 && isEqual(formData, value)) {
        return addNotification({
          icon: <Notifications color="white" />,
          title: "Error!",
          message: "No changes to save",
          color: "error",
        });
      } else {
        try {
          setLoading(true);
          const isNewUser = !formData?.u_id;
          const response = isNewUser
            ? await authService.insert_user({
                attributes: { user_data: formData },
              })
            : await authService.update_user({
                attributes: { user_data: formData },
              });
          if (response?.status === 1) {
            isNewUser
              ? manage_store_data({
                  name: "users",
                  data: response?.data,
                  type: "insert",
                })
              : manage_store_data({
                  name: "users",
                  key: "u_id",
                  data: response?.data,
                  type: "update",
                });
            addNotification({
              icon: <Notifications color="white" />,
              title: "Success!",
              message: response?.message,
              color: "success",
            });
            setLoading(false);
            handleClose();
          }
        } catch (error) {
          addNotification({
            icon: <Notifications color="white" />,
            title: "Error!",
            message: "Somthing Went Wrong!",
            color: "error",
          });
          setLoading(false);
        }
      }
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === "checkbox" ? checked : value;
    setFormData((prev) => ({
      ...prev,
      [name]: fieldValue,
    }));
    const newErrors = validateForm({ ...formData, [name]: fieldValue });
    if (Object.keys(newErrors).length === 0) {
      setErrors((prevErrors) => {
        const { [name]: removedError, ...rest } = prevErrors;
        return rest;
      });
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: newErrors[name] || null,
      }));
    }
  };

  const handleAutocompleteChange = (name, value) => {
    let fieldValue = value?.value || "";
    setFormData((prev) => ({
      ...prev,
      [name]: fieldValue,
    }));
    const newErrors = validateForm({ ...formData, [name]: fieldValue });
    if (Object.keys(newErrors).length === 0) {
      setErrors((prevErrors) => {
        const { [name]: removedError, ...rest } = prevErrors;
        return rest;
      });
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: newErrors[name] || null,
      }));
    }
  };

  const handleSwitchChange = (name) => (e) => {
    if (
      name === "submit" ||
      name === "result" ||
      name === "reply" ||
      name === "bill"
    ) {
      setFormData((prev) => ({
        ...prev,
        p_delete: { ...prev?.p_delete, [name]: e.target.checked ? 1 : null },
      }));
    }
    setFormData((prev) => ({
      ...prev,
      [name]: e.target.checked ? 1 : null,
    }));
  };

  const renderField = (field) => {
    const error = errors[field?.name];
    switch (field.type) {
      case "select":
        return (
          <Autocomplete
            disableClearable
            options={field?.options}
            value={
              field?.options.find(
                (opt) => opt.value === formData[field.name]
              ) || null
            }
            onChange={(_, value) => handleAutocompleteChange(field.name, value)}
            renderInput={(params) => (
              <TextField
                {...params}
                label={field.label}
                variant="standard"
                fullWidth
                error={!!error}
                helperText={error}
                required={field?.required}
              />
            )}
          />
        );

      case "checkbox":
      case "switch":
        return (
          <FormControlLabel
            control={
              <Switch
                checked={
                  Boolean(formData[field.name]) ||
                  Boolean(formData["p_delete"][field.name]) ||
                  false
                }
                onChange={handleSwitchChange(field.name)}
                color="secondary"
              />
            }
            label={field.label}
            labelPlacement="start"
            sx={{
              justifyContent: "space-between",
              marginLeft: 0,
              marginRight: 0,
              width: "100%",
            }}
          />
        );

      default:
        return (
          <BTInput
            name={field.name}
            label={field.label}
            type={field.type || "text"}
            value={formData[field.name] || ""}
            onChange={handleChange}
            variant="standard"
            fullWidth
            required={field?.required}
            error={!!error}
            helperText={error}
            {...field.props}
          />
        );
    }
  };

  const formFields = [
    {
      name: "first_name",
      label: "First Name",
      type: "text",
      gridSize: { xs: 12, md: 4 },
      required: true,
    },
    {
      name: "middle_name",
      label: "Middle Name",
      type: "text",
      gridSize: { xs: 12, md: 4 },
      required: true,
    },
    {
      name: "last_name",
      label: "Last Name",
      type: "text",
      gridSize: { xs: 12, md: 4 },
      required: true,
    },

    {
      name: "u_email",
      label: "Email Address",
      type: "text",
      gridSize: { xs: 12, md: 4 },
      required: true,
    },
    {
      name: "u_mo_no",
      label: "Mobile Number",
      type: "tel",
      gridSize: { xs: 12, md: 4 },
      required: true,
    },
    {
      name: "u_password",
      label: "Password",
      type: "password",
      gridSize: { xs: 12, md: 4 },
      required: true,
    },
    {
      name: "u_type",
      label: "User Type",
      options: filterRoles,
      type: "select",
      gridSize: { xs: 12, md: 3 },
    },
    {
      name: "u_desc",
      label: "Description",
      type: "text",
      gridSize: { xs: 9 },
    },
  ];
  const permissions_fields = [
    {
      name: "Masters",
      fields: [
        {
          name: "p_size",
          label: "Size",
          type: "checkbox",
        },
        {
          name: "p_service",
          label: "Service",
          type: "checkbox",
        },
        {
          name: "p_party",
          label: "Party",
          type: "checkbox",
        },
        {
          name: "p_pl",
          label: "Pricelist",
          type: "checkbox",
        },
        {
          name: "p_conv_rate",
          label: "Conversion rate",
          type: "checkbox",
        },
        {
          name: "p_attr",
          label: "Attributes",
          type: "checkbox",
        },
        {
          name: "p_user",
          label: "User",
          type: "checkbox",
        },
      ].filter((field) => userHasPermission[field.name]),
    },
    {
      name: "Transactions",
      fields: [
        {
          name: "p_submit",
          label: "Submissions",
          type: "checkbox",
        },
        {
          name: "p_results",
          label: "Results",
          type: "checkbox",
        },
        {
          name: "p_replies",
          label: "Replies",
          type: "checkbox",
        },
        {
          name: "p_returns",
          label: "Returns",
          type: "checkbox",
        },
        {
          name: "p_billing",
          label: "Billing",
          type: "checkbox",
        },
        {
          name: "p_reports",
          label: "Reports",
          type: "checkbox",
        },
      ].filter((field) => userHasPermission[field.name]),
    },
    {
      name: "Delete controls",
      fields: [
        {
          name: "submit",
          label: "Submissions",
          type: "checkbox",
        },
      ],
    },
  ];
  return (
    <BTDialogBox
      open={Boolean(open)}
      fullWidth
      maxWidth="md"
      maxHeight={"600px"}
      minHeight={"600px"}
      onSubmit={submitUser}
      close={handleClose}
      title={actionType === 1 ? "Add user" : "Edit user"}
      buttons={[
        {
          name: "Cancel",
          color: "secondary",
          size: "small",
          onClick: handleClose,
        },
        {
          name: actionType === 1 ? "Submit" : "Edit",
          variant: "gradient",
          type: "submit",
          color: "dark",
          size: "small",
          disabled: loading,
          loading: loading,
          loadingComponent: (
            <Fragment>
              <svg width={0} height={0}>
                <defs>
                  <linearGradient
                    id="my_gradient"
                    x1="0%"
                    y1="0%"
                    x2="0%"
                    y2="100%">
                    <stop offset="0%" stopColor="#e01cd5" />
                    <stop offset="100%" stopColor="#1CB5E0" />
                  </linearGradient>
                </defs>
              </svg>
              <CircularProgress
                size={22}
                sx={{
                  "svg circle": { stroke: "url(#my_gradient)" },
                }}
              />
            </Fragment>
          ),
          sx: { ml: 2, width: "80px" },
        },
      ]}>
      <Grid container spacing={1}>
        {formFields.map((field) => (
          <Grid size={{ ...field.gridSize }} key={field.name}>
            {renderField(field)}
          </Grid>
        ))}
        <Grid item xs={12}>
          <Grid container spacing={2} sx={{ mt: 2 }}>
            {permissions_fields.map((section) => (
              <Grid
                size={{ xs: 12 }}
                xs
                key={section.name}
                border={"1px solid #e0e0e0"}
                borderRadius={"8px"}
                backgroundColor="#f9f9f9"
                p={1}>
                <BTTypography fontWeight={"bold"} variant="body2">
                  {section.name}
                </BTTypography>
                <Grid container spacing={1}>
                  {section.fields.map((field) => (
                    <Grid item xs={12} sm={6} key={field.name}>
                      {renderField(field)}
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </BTDialogBox>
  );
};

export default Adduser;
